<template>
    <component
        :is="is"
    >
        <slot />
    </component>
</template>

<script>
import { container } from '@/js/util/menu';
import dynamicComponent from '@/js/mixins/dynamic-component';

export default {
    name: 'MenuDesktop',
    defaultTag: 'div',
    mixins: [dynamicComponent],
    inject: { container },
};
</script>



// WEBPACK FOOTER //
// src/components/navigation/MenuDesktop.vue